export function init(timeLimit: number, clockDiv: HTMLDivElement) {
    const counterElement: SVGTextElement | null = clockDiv.querySelector('#countdown-number');
    const circle = clockDiv?.querySelector('#circle') as SVGCircleElement;

    if (!clockDiv)
        console.warn("no clock defined")
    if (!counterElement)
        console.warn("cannot find a #countdown-number inside clock")
    if (!circle)
        console.warn("cannot find a #circle-number inside clock svg")

    const r: number = Number(circle?.getAttribute('r'));
    const circumference = (2 * r * Math.PI);
    if (circle && !r) {
        console.warn("Circle element has no r attribute")
    }
    const works = circle && r && counterElement && circumference
    if (works) clockDiv.style.visibility = "hidden"
    let paused = true;
    let start: number = 0
    return {
        start: () => {
            if (works) {
                console.log("starting clock");
                clockDiv.style.visibility = "visible"
                start= new Date().getTime()
                paused = false;
                // stop any previous
                circle.style.removeProperty("transition")
                circle.removeAttribute('stroke-dasharray');
                circle.removeAttribute('stroke-dashoffset');

               setTimeout(()=>{
                   // start
                   circle.style.transition = `all ${timeLimit}s linear`
                   circle.setAttribute('stroke-dasharray', circumference.toString());
                   circle.setAttribute('stroke-dashoffset', circumference.toString());
               },0)

                requestAnimationFrame(tick);
            }
        },
        stop: ()=>{
            clockDiv.style.visibility = "hidden"
            paused = true
            circle.style.removeProperty("transition")
            circle.removeAttribute('stroke-dasharray');
            circle.removeAttribute('stroke-dashoffset');
        }
    }

    function tick() {
        const now = new Date().getTime()
            , elapsed = now - start
        setCounterText(String(Math.floor(timeLimit - (elapsed / 1000))))
        if (!paused) requestAnimationFrame(tick);
    }

    function setCounterText(v: string) {
        if (counterElement)
            counterElement.innerHTML = v
    }
}


